import React, { Component, Fragment } from "react";
import {
  extractBarcodeValue,
  extractImageValue,
  extractAiFlags,
} from "../../store/form.answer.extract";
import {
  CircularProgress,
  FormHelperText,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import { Typography } from "@material-ui/core";
import { currentSectionState, openSectionState } from "../../store/form.store";
import { textAnswer } from "../../store/form.answer.fill";
import { AiStatusOverlay } from "../../../components/AiStatusOverlay";
import {
  GE_ID_KEYS,
  GE_ID_TAG_PROPERTIES,
  GE_ID_TAG_STATUS,
} from "../../../utility/Constant";
import green from "@material-ui/core/colors/green";
import red from "@material-ui/core/colors/red";
import FormFillerService from "../../../services/review-portal-services/form-filler.service";

const formFillerService = new FormFillerService();

export class BarcodeScanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      // helpTextValue: "",
      imageValue: [],
      editable: false,
      geIdTagData: { geIdTagging: false, loading: false, status: null },
      aiFlags: {},
    };
    this.debounceTimer = null;
  }
  componentDidMount() {
    let expanded = "";
    this.sectionStateSubscription = openSectionState.subscribe((sectionId) => {
      expanded = sectionId;
    });
    this.currentSectionSubscription = currentSectionState.subscribe(
      (section) => {
        this.setState({ editable: section === expanded });
      },
    );
    this.onLoadPage(this.props);
    // if (this.props.element.properties.answerLabel) {
    //   this.onLoadHelpText(this.props);
    // }
    if (this.props.element.properties.allowFileUpload) {
      this.onLoadImage(this.props);
    }
    this.setState((prevState) => ({
      geIdTagData: {
        ...prevState.geIdTagData,
        geIdTagging: this.props?.element?.properties?.geIdTagging,
      },
    }));
  }

  componentWillUnmount() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    if (this.sectionStateSubscription) {
      this.sectionStateSubscription.unsubscribe();
    }
    if (this.currentSectionSubscription) {
      this.currentSectionSubscription.unsubscribe();
    }
  }

  onLoadPage(props) {
    if (props.element) {
      let answer = props.element.answer;
      let userResponse = extractBarcodeValue(answer);
      if (userResponse) {
        if (props?.element?.properties?.geIdTagging) {
          this.setState((prevState) => ({
            geIdTagData: {
              ...prevState.geIdTagData,
              loading: true,
              status: null,
            },
          }));
          this.silentGeIDTagValidation(userResponse);
        }
        this.setState({
          value: userResponse,
        });
      }
    }
  }

  // onLoadHelpText(props) {
  //   const answerLabel = props.element.properties.answerLabel;
  //   if (answerLabel) {
  //     this.setState({ helpTextValue: answerLabel });
  //   }
  // }

  onLoadImage(props) {
    if (props.element) {
      let image = props.element.answer;
      let imageResponse = extractImageValue(image);
      if (imageResponse) {
        this.setState({ imageValue: imageResponse });
      }
      this.setState({ aiFlags: extractAiFlags(props.element.answer) });
    }
  }

  silentGeIDTagValidation = async (geIdTagValue) => {
    if (!geIdTagValue || !geIdTagValue.trim()) {
      this.setState((prevState) => ({
        geIdTagData: {
          ...prevState.geIdTagData,
          status: null,
          loading: false,
        },
      }));
      return;
    }

    try {
      const result = await formFillerService.validateGeIdTag(
        this.props.formDataId,
        geIdTagValue,
      );

      if (result?.data?.[GE_ID_KEYS.STATUS] === GE_ID_TAG_STATUS.VALID) {
        this.setState((prevState) => ({
          geIdTagData: {
            ...prevState.geIdTagData,
            status: GE_ID_TAG_STATUS.VALID,
            loading: false,
          },
        }));
        return;
      }

      this.setState((prevState) => ({
        geIdTagData: {
          ...prevState.geIdTagData,
          status: GE_ID_TAG_STATUS.INVALID,
          loading: false,
        },
      }));
    } catch (error) {
      this.setState((prevState) => ({
        geIdTagData: {
          ...prevState.geIdTagData,
          status: GE_ID_TAG_STATUS.INVALID,
          loading: false,
        },
      }));
    }
  };

  onChange = (event) => {
    const value = event.target.value;
    if (this.state.geIdTagData?.geIdTagging) {
      this.setState((prevState) => ({
        geIdTagData: {
          ...prevState.geIdTagData,
          loading: true,
        },
      }));
      this.props.updateGeIdTagProperty(GE_ID_TAG_PROPERTIES.GE_ID_TAG, value);
      this.props.updateGeIdTagProperty(
        GE_ID_TAG_PROPERTIES.MANUFACTURER_NAME,
        null,
      );
      this.props.updateGeIdTagProperty(GE_ID_TAG_PROPERTIES.STATUS, null);
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(async () => {
        this.silentGeIDTagValidation(value);
      }, 1000);
    }
    this.setState({ value: value });
    let answerNode = textAnswer(value, this.props?.element?.answer);
    if (this.props.onChange !== undefined) {
      this.props.onChange(answerNode, this.props.element);
    }
  };

  render() {
    return (
      <Fragment>
        {this.state.editable ? (
          <>
            <TextField
              id="scannerTextField"
              fullWidth
              required
              variant="outlined"
              error={this.props.hasError}
              value={this.state.value}
              onChange={this.onChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {this.state.geIdTagData.loading ? (
                      <CircularProgress size={24} />
                    ) : this.state.geIdTagData.status ===
                      GE_ID_TAG_STATUS.VALID ? (
                      <CheckCircleIcon style={{ color: green[500] }} />
                    ) : this.state.geIdTagData.status ===
                      GE_ID_TAG_STATUS.INVALID ? (
                      <CancelIcon style={{ color: red[500] }} />
                    ) : null}
                  </InputAdornment>
                ),
              }}
            />
            {this.state.geIdTagData.status === GE_ID_TAG_STATUS.VALID ? (
              <Typography style={{ color: green[600], marginTop: 8 }}>
                VALID GEV ID TAG
              </Typography>
            ) : this.state.geIdTagData.status === GE_ID_TAG_STATUS.INVALID ? (
              <Typography style={{ color: red[600], marginTop: 8 }}>
                INVALID GEV ID TAG
              </Typography>
            ) : null}

            {this.props.element.properties.answerLabel && (
              <FormHelperText>
                {this.props.element.properties.answerLabel}
              </FormHelperText>
            )}
          </>
        ) : (
          <Typography>{this.state.value}</Typography>
        )}
        {/* {this?.state?.helpTextValue && (
          <FormHelperText>{this.state.helpTextValue}</FormHelperText>
        )} */}
        {this.props.element.properties.allowFileUpload &&
        this.state.imageValue.length ? (
          <AiStatusOverlay
            imageList={this.state.imageValue}
            aiVerificationStatus={this.state.aiFlags.aiVerificationStatus}
            aiVerificationMessage={this.state.aiFlags.aiVerificationMessage}
          />
        ) : null}
      </Fragment>
    );
  }
}
export default BarcodeScanner;
